import React, { useState } from 'react';
import { InstantSearch, Configure } from 'react-instantsearch-dom';

import DesktopOnly from 'components/consumer/DesktopOnly';
import useAllOptions from 'data-hooks/useAllOptions';
import StaticProductResults from '../../instant-search/components/StaticProductResults';
import DesktopFiltersSidebar from './DesktopFiltersSidebar';

const SearchProductsContent = ({
  colorFiltered,
  facetFilters,
  hitsPerPage,
  inactive,
  indexName,
  invalidProductIds,
  loadRest,
  onIndexChange,
  removeProductIdFromList,
  searchClient,
  searchState,
  searchStateQuery,
  setInactive,
  toggleIsSearchOpen,
  updateInvalidProductIds,
}) => {
  const [productsLoading, setProductsLoading] = useState(false);
  const [lastQuery, setLastQuery] = useState('');
  const [lastQueryTopThreeRes, setLastQueryTopThreeRes] = useState([]);
  const allOptionsData = useAllOptions();

  return (
    <InstantSearch
      searchClient={searchClient}
      searchState={searchState}
      indexName={indexName}
      key={`${searchStateQuery}${searchState.configure.facetFilters}${indexName}`}
    >
      <Configure
        query={searchStateQuery}
        hitsPerPage={hitsPerPage}
        facetFilters={facetFilters}
        numericFilters={['item_availability<2', 'visibility>0', 'visibility<4']}
        attributesToRetrieve={['_highlightResult', 'product_id']}
      />

      <StaticProductResults
        allOptionsData={allOptionsData}
        colorFiltered={colorFiltered}
        inactive={inactive}
        invalidProductIds={invalidProductIds}
        lastQuery={lastQuery}
        lastQueryTopThreeRes={lastQueryTopThreeRes}
        layout="minimal"
        loadingMore={productsLoading}
        loadRest={loadRest}
        optionState="allOpts"
        removeProductIdFromList={removeProductIdFromList}
        searchStateQuery={searchStateQuery}
        setInactive={setInactive}
        setLastQuery={setLastQuery}
        setLastQueryTopThreeRes={setLastQueryTopThreeRes}
        setLoading={setProductsLoading}
        sidebarHeader={
          <DesktopOnly>
            <DesktopFiltersSidebar
              index={indexName}
              onIndexChange={onIndexChange}
              searchState={searchState}
            />
          </DesktopOnly>
        }
        toggleSearchOpen={toggleIsSearchOpen}
        updateInvalidProductIds={updateInvalidProductIds}
        variant="advanced-search"
      />
    </InstantSearch>
  );
};

export default SearchProductsContent;
